import { useEffect } from "react";

import {
  FetchCollectionsQueryResult,
  useFetchCollectionsQuery,
} from "@src/generated";

export function useCollections() {
  const queryResult: FetchCollectionsQueryResult = useFetchCollectionsQuery({
    variables: { endCursor: null },
  });

  const fetchAllPages = async () => {
    if (!queryResult.data?.collections?.pageInfo.hasNextPage) return;
    let hasNextPage: boolean =
      queryResult.data?.collections?.pageInfo.hasNextPage ?? false;
    let endCursor: string | null | undefined =
      queryResult.data?.collections?.pageInfo.endCursor;

    while (hasNextPage && endCursor) {
      const result = await queryResult.fetchMore({
        variables: { endCursor },
      });

      hasNextPage = result.data?.collections?.pageInfo.hasNextPage ?? false;
      endCursor = result.data?.collections?.pageInfo.endCursor;
    }
  };
  useEffect(() => {
    if (!queryResult.loading && queryResult.data) {
      void fetchAllPages();
    }
  }, [queryResult.loading, queryResult.data]);

  return queryResult.data;
}
